/**
 * Проверка за валидно име на домейн.
 * Валидното име на домейн е:
 * - Изписано само с латиница (за всички TLD-та)
 * - Изписано само на кирилица (за определени TLD-та)
 * - XN име (започващо с XN--)
 * Невалидното име на домейн:
 * - Изписано едновременно на латиница/кирилица.
 * - Започващо/завърщващо с тире.
 * - Невалидно XN име (което не се транслира правилно към кирилица).
 **/
export function _validateDomainNameSimple(domainNameFull) {
	// Валидира име на домейн.

	/**
	 * https://jira.superhosting.bg/browse/ORDER-35
	 */
	domainNameFull = domainNameFull.replace(/^www\./, '');

	domainNameFull = domainNameFull.toLowerCase().trim();
	const arrDomainData = domainNameFull.split('.');
	const domainName = arrDomainData[0];
	// const domainTld = domainNameFull.substr(domainName.length + 1);
	////////////////////////////////////////////
	////////////////////////////////////////////
	/**
	 * https://pi.superhosting.bg/public/index.php?path_info=projects%2Fanglijska-versiya-testvane%2Ftasks%2F53
	 * Поне два символа
	 */
	if (domainName.length <= 2) {
		throw 'DOMAIN_NAME_LENGTH_ERROR';
	}
	////////////////////////////////////////////
	////////////////////////////////////////////
	const t = domainNameFull.replace(' ', '');
	if (t !== domainNameFull) {
		throw 'DOMAIN_NAME_INVALID_ERROR';
	}
	////////////////////////////////////////////
	////////////////////////////////////////////
	const domTmp = domainName.replace(/[.`!,?<>/()*@#%]/gi, '');
	if (domTmp !== domainName) {
		throw 'DOMAIN_NAME_DISALLOWED_ERROR';
	}
	////////////////////////////////////////////
	////////////////////////////////////////////
	// Валидира името на домейна, ако името на домейна е с латински букви.
	const dNum = domainName.replace(/[0123456789-]/gi, '');
	const dEn = domainName.replace(/[abcdefghijklmnopqrstuvwxyz0123456789-]/gi, '');
	const dBg = domainName.replace(/[абвгдежзийклмнопрстуфхцчшщъыьэюя0123456789-]/gi, '');
	if (dNum === '') {
		return;
	}

	/*Проверка дали съдържа едновременно и БГ символи и EN символи.*/
	if ((dEn !== '') && (dBg !== '')) {
		throw 'DOMAIN_NAME_INVALID_CYR_LAT_ERROR';
	}
	////////////////////////////////////////////
	////////////////////////////////////////////
	// Проверка дали името започва или завършва с тире.
	const dTmp = domainName.replace(/^-+|-+$/g, '');
	if (dTmp !== domainName) {
		throw 'DOMAIN_NAME_HYPHEN_ERROR';
	}
	////////////////////////////////////////////
	////////////////////////////////////////////
	// let tldData = {};
	//
	// if (domainTld) {
	// 	tldData = DomainTLDS[domainTld];
	// 	if (typeof tldData === 'undefined') {
	// 		throw 'DOMAIN_TLD_INVALID_ERROR';
	// 	}
	//
	// 	if (parseInt(tldData.ia) === 0) {
	// 		throw 'DOMAIN_TLD_INVALID_ERROR';
	// 	}
	//
	// 	if (parseInt(tldData.tr === 0)) {
	// 		throw 'DOMAIN_TLD_INVALID_ERROR';
	// 	}
	// }
	/**
	 * https://ps.superhosting.bg/projects/350?modal=Task-22909-350
	 * Проверява се дали даденото TLD има изискване името на домейна да е само на кирилица
	 */

	// if (parseInt(tldData.xno) === 1) {
	// 	const domTmpTLD = domainName.replace(/[абвгдежзийклмнопрстуфхцчшщъыьэюя0123456789-]/gi, '');
	// 	if (domTmpTLD !== '') {
	// 		throw 'DOMAIN_NAME_LANG_ERROR';
	// 	}
	// }
	//
	// let allowXN = (parseInt(tldData.axn) === 1);
	// if (parseInt(isTransfer) === 1) {
	// 	allowXN = (parseInt(tldData.xnt) === 1);
	// }
	// const isXN = (domainName.substr(0, 4) === 'xn--');
	// const registrar = tldData.rg;
	// if (isXN && !allowXN) {
	// 	throw 'DOMAIN_NAME_XN_ERROR';
	// }
	// if ((dBg === '') && !allowXN) {
	// 	throw 'DOMAIN_NAME_XN_ERROR';
	// }


	/**
	 * Ако домейна на кирилица и registrar-а е Регистър.БГ. се проверява
	 * дали в името на домейна има поне 1 буква, която да не прилича на латинското
	 * си изписване:
	 * Когато ИНТЕРНЕТ ИМЕТО се изписва на кирилица (IDN), то трябва да съдържа букви
	 * само от кирилицата и да включва поне една отличаваща се визуално буква спрямо
	 * латинската азбука (големи и/или малки букви): б, г, д, ж, и, й, л, п, ф, ц, ч, ш, щ, ъ, ь, ю, я.
	 * https://www.register.bg/user/static/rules/bg/index.html
	 */
	// if (registrar === 'RBG' || (isTransfer && registrar === 'IBGCYR')) {
	// 	// Дали домейна е на кирилица:
	// 	if ((dBg === '') && (dNum !== '')) {
	// 		const idnBG = domainName.replace(/[бгджийлпфцчшщъьюя]/gi, '');
	//
	// 		if (idnBG === domainName) {
	// 			throw 'DOMAIN_NAME_IDN_BG_LETTER_ERROR';
	// 		}
	// 	}
	// }
}

export function _validateIsEmpty(string) {
	string = string.trim();
	return (!(string === '' || string === undefined));
}

export function _validateEmail(email) {
	const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(String(email).toLowerCase());
}

export function _validateURL(url) {
	const re = new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');
	return re.test(url);
}

// export function _validateTLDForTransfer(tld) {
//
// 	if (typeof DomainTLDS[tld] === 'object') {
// 		const tldData = DomainTLDS[tld];
// 		if (tldData.tr === "1") {
// 			return;
// 		}
// 		throw 'DOMAIN_TLD_INVALID_ERROR';
// 	}
// 	throw 'DOMAIN_TLD_INVALID_ERROR';
// }

/**
 * Проверка за валидно име на cPanel
 * Валидното име на cPanel е:
 * - Изписано само с латиница + цифри
 * - Минимум 6 символа
 * - Първият символ е буква
 **/
export function _validateCPanelName(cPanelName) {
	if (cPanelName.length < 6) {
		throw 'CPANEL_NAME_LENGTH_ERROR';
	}


	const letters = /^[0-9a-zA-Z]+$/;
	if (!cPanelName.match(letters)) {
		throw 'CPANEL_NAME_LETTERS_ERROR';
	}

	const firstChar = cPanelName.charAt(0);
	if (firstChar >= '0' && firstChar <= '9') {
		throw 'CPANEL_NAME_FIRST_CHAR_NUMBER_ERROR';
	}


	const blacklisted = [
		'adm',
		'admin',
		'bin',
		'cpanel',
		'cpanelhorde',
		'cpanelphpmyadmin',
		'cpanelphppgadmin',
		'cpanelroundcube',
		'daemon',
		'dbus',
		'ftp',
		'games',
		'gopher',
		'haldaemon',
		'halt',
		'lp',
		'mail',
		'mailbgsh',
		'mailman',
		'mailnull',
		'megalres',
		'mysql',
		'nagios',
		'named',
		'news',
		'nobody',
		'ntp',
		'operator',
		'root',
		'sh',
		'shaccount',
		'shmanage',
		'shostbg',
		'shutdown',
		'smmsp',
		'sshd',
		'sync',
		'uucp',
		'vcsa',
		'xfs'
	];
	if (blacklisted.includes(cPanelName)) {
		throw 'CPANEL_NAME_BLACKLISTED_ERROR';
	}
}

export function _sanitizePhoneNumber(phoneNumber) {
	return String(phoneNumber ?? '').replace(/[\p{C}\p{Z}\s+\-().]/gu, '');
}

export function _validatePhoneNumber(phoneNumber) {
	const re = new RegExp('^[0-9]{7,15}$');
	return re.test(_sanitizePhoneNumber(phoneNumber));
}

export default class HelperValidator {
	static validateDomainNameSimple(domainNameFull) {
		_validateDomainNameSimple(domainNameFull);
	}

	static validateIsEmpty(string) {
		return _validateIsEmpty(string);
	}

	static validateEmail(email) {
		return _validateEmail(email);
	}

	static validateURL(url) {
		return _validateURL(url);
	}

	// static validateTLDForTransfer(tld) {
	// 	_validateTLDForTransfer(tld);
	// }

	static validateCPanelName(cPanelName) {
		_validateCPanelName(cPanelName);
	}

	static validatePhoneNumber(phoneNumber) {
		return _validatePhoneNumber(phoneNumber);
	}

	static sanitizePhoneNumber(phoneNumber) {
		return _sanitizePhoneNumber(phoneNumber);
	}
}

